"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withStore = exports.useStore = exports.StoreProvider = void 0;
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var StoreContext = (0, preact_1.createContext)(null);
var StoreProvider = function (_a) {
    var children = _a.children, store = _a.store;
    return (0, preact_1.h)(StoreContext.Provider, { value: store }, children);
};
exports.StoreProvider = StoreProvider;
var useStore = function () { return (0, hooks_1.useContext)(StoreContext); };
exports.useStore = useStore;
var withStore = function (Component) { return function (props) {
    return (0, preact_1.h)(Component, __assign({ store: (0, exports.useStore)() }, props));
}; };
exports.withStore = withStore;
